import Entity from '../../../entity';

interface IBank {
  id: string;
  name: string;
  logoUrl?: string | null;
  logoBase64Encoding?: string | null;
}

interface IFinancialAccount {
  id: string;
  name: string;
  mask: string;
  bank: IBank;
}

interface IAccountSecondaryElementProps {
  financialAccount: IFinancialAccount;
  showName?: boolean;
}

const AccountSecondaryElement = ({ financialAccount, showName = false }: IAccountSecondaryElementProps) => {
  return (
    <div className="flex min-w-0 items-center gap-2">
      <Entity.Avatar entity={financialAccount} size="2xs" />
      <div className="flex min-w-0 items-center gap-1">
        {showName && <span className="text-primary truncate text-sm font-medium">{financialAccount.name}</span>}
        <span className="text-tertiary shrink-0 text-sm font-medium">(••{financialAccount.mask})</span>
      </div>
    </div>
  );
};

export default AccountSecondaryElement;
